var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['scheme', { 'all-schemes': _vm.allSchemesView }]},[(!_vm.allSchemesView)?_c('Tabs',{attrs:{"schemeName":_vm.selectedScheme.title}}):_vm._e(),_c('div',[_c('keep-alive',{attrs:{"include":"Map"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }